var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dui-store-value"},[((_vm.storeValue === null) && !!_vm.emptyValue)?_c('span',[_vm._v(_vm._s(_vm.emptyValue))]):_vm._e(),_vm._v(" "),(_vm.storeValue !== null)?_c('span',[_vm._v(_vm._s(_vm.storeValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }